export const getCourseTypeSorted = (courseType, courses) => (courses || [])
  .filter(course => course.courseType === courseType)
  .sort((a, b) => (new Date(a.goLiveDate || a.dateAdded) - new Date(b.goLiveDate || b.dateAdded)));
